import React from 'react';
import { NewclickResultScreenDesktopWidget } from '@alfa-bank/newclick-result-screen-widget/desktop';

import { ButtonDesktop } from '@alfalab/core-components/button/desktop';
import { SbpSignBoxMWhiteIcon } from '@alfalab/icons-logo/SbpSignBoxMWhiteIcon';

import { useErrorSreen } from '../../../shared/hooks/use-error-screen';
import { useHandleTransfer } from '../../../shared/hooks/use-handle-transfer';

import styles from './index.module.css';

export const TransferButton = () => {
    const { handleSubmit, loading } = useHandleTransfer();
    const errorSreenProps = useErrorSreen();

    return (
        <React.Fragment>
            <NewclickResultScreenDesktopWidget {...errorSreenProps} />
            <ButtonDesktop
                className={styles.button}
                view='primary'
                block={true}
                loading={loading}
                leftAddons={<SbpSignBoxMWhiteIcon />}
                onClick={handleSubmit}
            >
                Перевести
            </ButtonDesktop>
        </React.Fragment>
    );
};
